import React from 'react'

import styled from 'styled-components'

import { AdCampaignStrategyEnum } from 'src/Redux/ad-campaignApi'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { Promotion } from '../../../../AuthPages/CreateAdsCampaign/SelectStrategy/Promotion'

type Props = {
  onSelectStrategy: (strategy: AdCampaignStrategyEnum) => void
}

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`

const Br = styled.br`
  display: none;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    display: block;
  }
`
export const SelectAdsStrategy: React.FC<Props> = (props) => {
  const { onSelectStrategy } = props
  return (
    <Container>
      <Promotion
        highlighted
        onClick={() => onSelectStrategy(AdCampaignStrategyEnum.PLAYLIST)}
        title='Promote multiple releases with your playlist'
        tags={['Lower cost per stream', 'Long-term exposure']}
      >
        <span>
          Turn your playlist into a powerful marketing tool that promotes all
          your releases 24/7.{' '}
        </span>
        <Br />
        <span>
          Build a growing fanbase while reducing your cost per stream.
        </span>
      </Promotion>
      <Promotion
        onClick={() => onSelectStrategy(AdCampaignStrategyEnum.TRACK)}
        title='Promote a single track'
        tags={['Higher cost per stream', 'Short-term exposure']}
      >
        <span>Promote one specific release with Meta Ads. </span>
        <Br />
        <span>
          Perfect for testing new music or pushing a single track — no playlist
          needed.
        </span>
      </Promotion>
    </Container>
  )
}
